import { Component, Input } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { SharedService } from 'app/shared/services/shared.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { HttpService } from 'app/shared/services/http.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'cdn-file-delete-component',
  templateUrl: './cdn-file-delete.component.html',
  styleUrls: ['./cdn-file-delete.component.scss'],
})
export class CdnFileDeleteComponent {
  @Input() public data: any;
  public isDeleting: boolean;
  public subscriptions: Array<any>;

  constructor(
    public sharedService: SharedService,
    public modalsService: ModalsService,
    public httpService: HttpService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = { id: 0 };
    this.isDeleting = false;
    this.subscriptions = [];
  }

  ngOnDestroy(): void {}

  ngOnChanges($event): void {
    this.data = $event.data.currentValue;
  }

  delete(): void {
    this.isDeleting = true;
    this.subscriptions.push(
      this.httpService.post('cdn_files/deleteFile', { id: this.data.id }).subscribe((response) => {
        if (!response.errors) {
          this.sharedService.showFlashMessage(this.dictionaryService.get('FILE_DELETED_SUCCESSFULLY'), 'success');
        } else {
          this.sharedService.showFlashMessage(this.dictionaryService.get('AN_ERROR_HAS_OCCURRED'), 'error');
        }

        this.isDeleting = false;
        this.sharedService.sendMessage('CDN_FILE_DELETE');
        this.modalsService.hideModal();
      })
    );
  }
}
